import { render, staticRenderFns } from "./CampaignStatementTable.vue?vue&type=template&id=3f84d45d&scoped=true&"
import script from "./CampaignStatementTable.vue?vue&type=script&lang=js&"
export * from "./CampaignStatementTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/black-dashboard/components/_campaigns-general-table.scss?vue&type=style&index=0&id=3f84d45d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84d45d",
  null
  
)

export default component.exports